(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomSectionTypeAttributeDetailController', CustomSectionTypeAttributeDetailController);

    CustomSectionTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomSectionTypeAttribute'];

    function CustomSectionTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomSectionTypeAttribute) {
        var vm = this;

        vm.customSectionTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customSectionTypeAttributeUpdate', function(event, result) {
            vm.customSectionTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
